import type { InjectionKey, Ref } from 'vue';

/** Final Dividends — 주주구성 시나리오. 생성 문서 세트를 결정한다. */
export type DivScenario = 'multiple' | 'sole_individual' | 'sole_corporate';

/** 패키지가 provide, 각 문서가 inject 해 문구(member/members)와 표시를 맞춘다. */
export const DIV_SCENARIO: InjectionKey<Ref<DivScenario>> = Symbol('finalDividendsScenario');

export const SCENARIO_LABEL: Record<DivScenario, string> = {
  multiple: 'Multiple Members',
  sole_individual: 'Sole Member (Individual)',
  sole_corporate: 'Sole Member (Corporate)',
};
